/**
 * @generated SignedSource<<783e113dd156a939036fa631dbe16025>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCostPeriodInput = {
  id: string;
  personId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteCostPeriodMutation$variables = {
  input: DeleteCostPeriodInput;
};
export type deleteCostPeriodMutation$data = {
  readonly deleteCostPeriod: {
    readonly deletedCostPeriodId: string | null;
  } | null;
};
export type deleteCostPeriodMutation = {
  variables: deleteCostPeriodMutation$variables;
  response: deleteCostPeriodMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCostPeriodPayload",
    "kind": "LinkedField",
    "name": "deleteCostPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCostPeriodId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCostPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCostPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e50b5d4cdc50d7815fbc6e00a13f3b5b",
    "id": null,
    "metadata": {},
    "name": "deleteCostPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCostPeriodMutation(\n  $input: DeleteCostPeriodInput!\n) {\n  deleteCostPeriod(input: $input) {\n    deletedCostPeriodId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea6ae02d2bc5ab33ecb7be5e1024a470";

export default node;
